// tslint:disable
/**
 * CONEXSYS Product Portal API
 * The API for the CONEXSYS Product Portal
 *
 * The version of the OpenAPI document: 2.0.0
 * Product: support@conexsys.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { virtualConfig as config } from '../../../config/virtual';
import { apiRequest, setEntitiesApiOperationState } from '../../../app/api';
import { ProductHelper } from '../classes';
import moment from 'moment';
import _ from 'lodash';

import { ProductEntities } from '../collections';
import { State_ApiOperationContextTypes } from '../../../storage';
import { UseCtx } from '../../../config/hooks';

export enum ProductApiOperation {
	readProducts = 'readProducts'
}

export interface ReadProductsRequest {
	eventId: string;
	modifiedFrom?: string;
	ids?: string[];
	queryLimit?: number;
	queryBookmark?: string;
}

/**
 * Read products
 */
export async function readProducts(
	ctx: UseCtx<any>,
	requestParameters: ReadProductsRequest
): Promise<ProductEntities> {
	const operationId = ProductApiOperation.readProducts;

	// get the attempt date now BEFORE the request is made so there is no GAP in time if the request takes awhile or fails
	const attemptDate: string = moment().toISOString();

	// make the api request
	const response = await apiRequest<ProductEntities, ReadProductsRequest>(
		ctx,
		config.apiId,
		operationId,
		requestParameters
	);

	let entities: ProductEntities | undefined = response.response.data;
	if (!entities) entities = [];

	if (entities.length > 0) {
		// set each entity.__state.eventId to the eventId from the params
		entities.forEach((entity, i, a) => {
			a[i].__state = _.merge(entity.__state || {}, {
				eventId: requestParameters.eventId
			});
		});

		// patch entities with an api success data for the operation
		setEntitiesApiOperationState<ProductEntities, ProductHelper>(
			ctx.virtual.product,
			entities,
			operationId,
			State_ApiOperationContextTypes.Success,
			attemptDate
		);
		// upsert the entities to the store
		ctx.virtual.product.upsert(entities);
	}

	// return the entities to the caller for direct reference
	return entities;
}
